module.exports = __webpack_public_path__ + "static/media/edit-3.54179a33.svg";